import * as Sentry from '@sentry/browser'; // eslint-disable-line import/no-namespace

const captureMessage = (message, options = {}) => {
  const {errorInfo, calledFrom} = options;

  try {
    Sentry.withScope(scope => {
      if (errorInfo) {
        scope.setExtra('errorInfo', errorInfo);
      }
      if (calledFrom) {
        scope.setExtra('calledFrom', calledFrom);
      }

      Sentry.captureMessage(message);
    });
  } catch (sentryError) {
    // eslint-disable-next-line no-console
    console.error('error reporting event to Sentry', sentryError);
    return null;
  }

  return Sentry.lastEventId();
};

export default captureMessage;
